import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

DashboardAstroLanguages.propTypes = {};

function DashboardAstroLanguages(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  

  const { logout } = useContext(AuthContext);

  const [languages, setLanguages] = useState([]);
const [selected, setSelected] = useState([]);
const [astrologerId, setAstrologerId] = useState(null);
const [astrologerStatusnew, setAstrologerStatusnew] = useState({ Named: "", Id: "" });

// Fetch astrologer ID from localStorage and check if languages are already set
useEffect(() => {
  const storedUserId = localStorage.getItem("astrologerId");
  if (storedUserId) {
    setAstrologerId(storedUserId);
  }

  // Fetch available languages
  axios.get('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/languages')
    .then(res => setLanguages(res.data))
    .catch(err => console.error(err));
}, []);

// Event handlers
const handleCheckboxChange = (id) => {
  setSelected(prev =>
    prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
  );
};
const [isSubmitting, setIsSubmitting] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();

  if (selected.length === 0) {
     toast.error("Please select at least one language before submitting.");
    return;
  }

  setIsSubmitting(true); // Disable button

  axios.post('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/selected-languages', {
    selectedLanguages: selected,
    astrologerId: astrologerId
  })
  .then(() => {
    return axios.post('https://adhigyanam-e92bf1bbbdb1.herokuapp.com/update-astrologer-language-status', {
      astrologerId: astrologerId
    });
  })
  .then(() => {
     toast.success("Languages preferences updated successfully!");

    // Delay redirect
    setTimeout(() => {
      window.location.href = "/completeprofile";
    }, 5000);
  })
  .catch(err => {
    console.error("Submit error:", err);
     toast.error("Submission failed. Please try again.");
    setIsSubmitting(false); // Re-enable on error
  });
};

  return (
    <>
    <Helmet>
            <title>Select Languages - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
         
        <Breadcrumbastrologer title="Select Languages" />
       
        <section className="account-section">
              <div className="tf-container">
                <div className="row">
                  <div className="wd-form-login">
                
                  <h5 style={{fontSize:"27px"}}>Set Language Preferences</h5>
                  <p style={{marginBottom:"20px"}}>Adhigyanam network interacts with people with different language preferences. Help us identify your language support to allow our customers connect with you based on their language preferences.</p>
                   
                      
                     
  <form onSubmit={handleSubmit} className="languages-form" style={{ textAlign: "center" }}>
  <div className="languages-grid">
    {languages.length === 0 ? (
      <div className="no-services">No languages available</div>
    ) : (
      languages.map(lang => (
        <label
          key={lang.Id}
          className={`language-row ${selected.includes(lang.Id) ? 'selected' : ''}`}
          tabIndex={0}
        >
          <div className="language-left">
            <input
              className="hidden-checkbox"
              id={`lang-${lang.Id}`}
              type="checkbox"
              checked={selected.includes(lang.Id)}
              onChange={() => handleCheckboxChange(lang.Id)}
            />
            <span className="custom-checkbox" aria-hidden="true">
              <svg viewBox="0 0 24 24" className="checkmark" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </span>
            <span className="language-name">{lang.Named}</span>
          </div>
        </label>
      ))
    )}
  </div>

  {/* keep your original button style — unchanged */}
  <div style={{ marginTop: 12 }}>
    <button type="submit" disabled={isSubmitting}>
      {isSubmitting ? "Please Wait..." : "Submit"}
    </button>
  </div>

  {/* scoped styles — paste inside component like you did earlier */}
  <style>{`
    .languages-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 12px;
      max-width: 900px;
      margin: 0 auto;
      padding: 6px 0;
    }

    @media (min-width: 800px) {
      .languages-grid { grid-template-columns: 1fr 1fr; }
    }
    @media (min-width: 1200px) {
      .languages-grid { grid-template-columns: 1fr 1fr 1fr; }
    }

    .language-row {
      display:flex;
      align-items:center;
      gap:12px;
      padding:12px;
      border-radius:10px;
      background: linear-gradient(180deg,#ffffff,#f9f9f9);
      border:1px solid #e8eaee;
      cursor:pointer;
      transition: transform 0.12s ease, box-shadow 0.12s ease;
      user-select:none;
    }
    .language-row:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 18px rgba(0,0,0,0.04);
    }
    .language-row.selected {
      background: linear-gradient(90deg,#f6fffb,#f3fff7);
      border-color: #dff3ea;
    }

    .language-left {
      display:flex;
      align-items:center;
      gap:12px;
      width:100%;
    }

    .language-name {
      font-size:15px;
      font-weight:600;
      color:#1f2937;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    /* Hide native checkbox */
    .hidden-checkbox {
      position:absolute;
      left:-9999px;
      opacity:0;
      width:1px;height:1px;
      pointer-events:none;
    }

    /* custom checkbox */
    .custom-checkbox {
      width:22px;height:22px;min-width:22px;
      border-radius:6px;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      background:#fff;
      border:1.5px solid #cfd8e3;
      box-shadow: inset 0 -2px 0 rgba(0,0,0,0.02);
      transition: background 0.12s, border-color 0.12s, transform 0.08s;
      flex-shrink:0;
    }
    .language-row.selected .custom-checkbox {
      background: #14a077;
      border-color: #14a077;
    }

    .custom-checkbox .checkmark {
      width:14px;height:14px;
      stroke:#fff; stroke-width:2; fill:none;
      stroke-linecap:round; stroke-linejoin:round;
      opacity:0; transition:opacity 0.12s;
    }
    .language-row.selected .custom-checkbox .checkmark { opacity:1; }

    .no-services {
      padding:14px;
      border-radius:8px;
      background:#fff9f7;
      border:1px solid #ffecd1;
      color:#bf3b0a;
      font-weight:600;
      max-width:900px;
      margin:0 auto;
    }

    /* Accessibility: keyboard focus */
    .language-row:focus {
      outline: 3px solid rgba(20,160,119,0.14);
      outline-offset:2px;
    }
  `}</style>
</form>
 <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
                        
                     
                        <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                                           
                                                                           <Link to="/completeprofile" className="forgot" style={{margin:"auto"}}>
                                                                                                                                                          Return To Verification Desk
                                                                                                                                                        </Link>
                                                                          </div>
                   
                  </div>
                </div>
              </div>
            </section>
       
      
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
     
      <Gotop />
    </>
  );
}

export default DashboardAstroLanguages;
